import { Header } from "@/sections/Header";
import { Hero } from "@/sections/Hero";
import { Features } from "@/sections/Features";
import { DashboardPreview } from "@/sections/DashboardPreview";
import { Pricing } from "@/sections/Pricing";
import { FAQ } from "@/sections/FAQ";
import { FinalCTA } from "@/sections/FinalCTA";
import { Footer } from "@/sections/Footer";
import { DemoFormModal } from "@/sections/DemoFormModal";
import { CookieBanner } from "@/sections/CookieBanner";
import { LanguageProvider } from "@/context/LanguageContext";
import { DemoFormProvider } from "@/context/DemoFormContext";

export default function LandingPage() {
  return (
    <LanguageProvider>
      <DemoFormProvider>
        <Header />
        <main>
          <Hero />
          <Features />
          <DashboardPreview />
          <Pricing />
          <FAQ />
          <FinalCTA />
        </main>
        <Footer />
        <DemoFormModal />
        <CookieBanner />
      </DemoFormProvider>
    </LanguageProvider>
  );
}
